import React, { useState, useEffect, useRef } from 'react';
// import config from '../../config';
// import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  // LayoutSingleColumn,
  // LayoutWrapperTopbar,
  // LayoutWrapperMain,
  // LayoutWrapperFooter,
  Footer,
  ExternalLink,
  NamedLink,
  // NewsletterForm,
  Slider,
  Slider2,
  PressSection,
  SectionHowItWorks,
  SectionSteps,
  Logo,
  LandingLocationSelect,
} from '../../components';

import SectionMission from '../../components/SectionMission/SectionMission';
import LazyLoad from 'react-lazyload';
// import selecticon from '../../assets/icons/select.png';
// import FormControl from '@material-ui/core/FormControl';
// import Select from '@material-ui/core/Select';

import { FormattedMessage } from '../../util/reactIntl';

import css from './LandingPage.css';

import { TweenMax } from 'gsap/all';

import { InView } from 'react-intersection-observer';

//ICONS
import insta from '../../assets/icons/socialmedia/instagram-icon.png';
import fb from '../../assets/icons/socialmedia/facebook-icon.png';
import linkedIn from '../../assets/icons/socialmedia/linkedIn-icon.png';

// import NGO from './NGO.png';
// import Dest from './destinations.png';

import heroImage from '../../assets/landingPage/Header_img_big.webp';
import heroImageSmall from '../../assets/landingPage/Header_img_small.webp';


import LoaderImage1 from '../../assets/loader/world.png';
import LoaderImage2 from '../../assets/loader/airplane.png';


import TextTransition, { presets } from 'react-text-transition';
// import { ThreeSixtySharp } from '@material-ui/icons';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

const LandingPage = () => {
  const [textTransitionIndex, setTextTransitionIndex] = useState(0);
  const [loadingState, setLoadingState] = useState(false);
  const [searchRegion, setSearchRegion] = useState('worldwide');
  const [search, setSearch] = useState(
    'bounds=85.051129%2C179.00736739%2C-75.14077719%2C-160.60200761'
  );

  const [sectionLink, setSectionLink] = useState(false);

  window.addEventListener('scroll', handleScroll);
  function handleScroll() {
    if (window.pageYOffset > window.innerHeight * 0.15) {
      setSectionLink(true);
    } else {
      setSectionLink(false);
    }
  }

  const topbarRef = useRef();
  const heroWrapperRef = useRef();
  const animaRef = useRef();
  const anima2Ref = useRef();

  var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  const WORDS =
    cookies.get('language') === 'en'
      ? ['education', 'nature protection', 'animal protection', 'equality']
      : ['Naturschutz', 'Bildung', 'Tierschutz', 'Gleichberechtigung'];

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener(
      'test',
      null,
      Object.defineProperty({}, 'passive', {
        function() {
          supportsPassive = true;
        },
      })
    );
  } catch (e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

  // call this to Disable
  function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  // call this to Enable
  function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  useEffect(() => {
    disableScroll();
    if (window !== undefined) window.scrollTo({ top: 0 });
    // add disableScroll to dependency? - weasel
  }, []);

  setTimeout(() => {
    enableScroll();
  }, 3000);

  if (window !== undefined) {
    if (window.location.hash) {
      window.location = '/';
    }
  }

  useEffect(() => {
    const textInterval = setInterval(() => {
      setTextTransitionIndex(textTransitionIndex + 1);
    }, 3000);
    return () => {
      clearInterval(textInterval);
    };
  }, [textTransitionIndex]);

  
  //preload the heroimageBig
  var link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = heroImage;
  document.head.appendChild(link);
  //preload the heroimageSmall
  var link2 = document.createElement("link");
  link2.rel = "preload";
  link2.as = "image";
  link2.href = heroImageSmall;
  document.head.appendChild(link2);

  const handleImageLoaded = () => {
    setTimeout(() => {
      setLoadingState(true);
      heroWrapperRef.current.classList.add(css.heroWrapper_active);

      setTimeout(() => {
        // var target = document.querySelector('#anima');
        animaRef.current.style.opacity = 1;
        TweenMax.staggerFrom(
          animaRef.current,
          1,
          {
            skewX: '5deg',
            skewY: '5deg',
            opacity: 0,
            y: 80,
          },
          0.27
        );
      }, 500);

      setTimeout(() => {
        topbarRef.current.style.opacity = 1;

        TweenMax.staggerFrom(
          topbarRef.current.Top,
          0.75,
          {
            opacity: 0,
          },
          0.67
        );

        anima2Ref.current.style.opacity = 1;

        TweenMax.staggerFrom(
          anima2Ref.current,
          0.75,
          {
            skewX: '5deg',
            skewY: '5deg',
            opacity: 0,
            y: 30,
          },
          0.27
        );
      }, 1000);
    }, 500);
  };

  // refactor for anon func? - weasel
  const setSection = num => {
    this.setState({ ...this.state, section: num });
  };

  const handleChange = event => {
    setSearchRegion(event.target.value);
    if (event.target.value === 'worldwide') {
      setSearch('bounds=85.051129%2C179.00736739%2C-75.14077719%2C-160.60200761');
    }

    if (event.target.value === 'africa') {
      setSearch('bounds=36.59497175%2C52.76846679%2C-36.15117826%2C-34.86957672');
    }
    if (event.target.value === 'southamerica') {
      setSearch('bounds=34.15056365%2C-25.99456573%2C-59.50348924%2C-150.22941462');
    }
    if (event.target.value === 'asia') {
      setSearch('bounds=64.09173416%2C169.49644716%2C-14.97311392%2C58.14770588');
    }
    if (event.target.value === 'europe') {
      setSearch('bounds=66.75842601%2C44.21184607%2C26.75060877%2C-31.82643116');
    }
  };

  // set up conditions for location based SEO

  const slideData = [
    {
      index: 0,
      itemsHeader: <FormattedMessage id="europe" />,
      headline: <FormattedMessage id="landing.story.headline3" />,
      location: <FormattedMessage id="almonte" />,
      src: require('../../assets/landingPage/slider_images/Erfolgsstory_Europa.webp'),
      link: '/l/global-tribe-shared-bedroom/62bd838d-c3b1-49a6-9265-7d690e1a225b',
      showAllLink: '/s?bounds=66.75842601%2C44.21184607%2C26.75060877%2C-31.82643116',

      item1_image: require('../../assets/landingPage/slider_images/Tinos.webp'),
      item1_link:
        '/l/tinos-ecolodge-little-stone-stable-entire-accomodation/63205ffd-8860-406f-ba26-b212dff41215',
      item1_header: "Tinos Ecolodge",
      item1_location: <FormattedMessage id="tinos" />,
      item1_rating: '4.95',
      item1_price: '95€',
      category1: require('../../assets/categories/environment.png'),
      category1Title: <FormattedMessage id="filter.category.environment" />,

      item2_image: require('../../assets/landingPage/slider_images/Zonca.webp'),
      item2_link:
        '/l/zonca-ecovillage-in-piemonte-italy-casa-in-mezzo-entire-accomodation/60f572e2-ed29-4a70-8aa6-232260f00ac7',
      item2_header: 'Zonca Ecovillage',
      item2_location: <FormattedMessage id="zonca" />,
      item2_rating: '4.95',
      item2_price: '59€',
      category2: require('../../assets/categories/education.png'),
      category2Title: <FormattedMessage id="filter.category.education" />,

      item3_image: require('../../assets/landingPage/slider_images/Esperanza.webp'),
      item3_link: '/l/esperanza-zentrum-fur-tierunterstutzte-padagogik-entire-accomodation/628e8233-d722-4d54-ada5-2a660f8e9515',
      item3_header: 'Esperanza',
      item3_location: <FormattedMessage id="oberndorf" />,
      item3_rating: '4.95',
      item3_price: '72€',
    },
    {
      index: 1,
      itemsHeader: <FormattedMessage id="southamerica" />,
      headline: <FormattedMessage id="landing.story.headline0" />,
      location: 'Fazenda Sauva, Brazil',
      src: require('../../assets/landingPage/slider_images/Fazenda_story.jpg'),
      link: '/l/fazenda-sauva-doublebedroom/60702e23-291a-4c32-9698-ec5fcf9c4905',
      showAllLink: '/s?bounds=34.15056365%2C-25.99456573%2C-59.50348924%2C-150.22941462',

      item1_image: require('../../assets/landingPage/slider_images/Fundacion.webp'),
      item1_link: '/l/fundacion-tiemp-de-juego-shared-bedroom/607026fd-41cb-4d6d-afa9-38beb0e0d6fa',
      item1_header: 'Fundación Tiempo de Juego',
      item1_location: <FormattedMessage id="cienaga" />,
      item1_rating: '4.95',
      item1_price: '12$',
      category1: require('../../assets/categories/education.png'),
      category1Title: <FormattedMessage id="filter.category.education" />,

      item2_image: require('../../assets/landingPage/slider_images/Quito.webp'),
      item2_link: '/l/ecoturismo-comunitario-yunguilla-twobedroom/63a8ae12-1101-4b75-8ed4-338d14577c7b',
      item2_header: 'Ecoturismo Comunitario Yunguilla',
      item2_location: <FormattedMessage id="quito" />,
      item2_rating: '4.95',
      item2_price: '45$',
      category2: require('../../assets/categories/environment.png'),
      category2Title: <FormattedMessage id="filter.category.environment" />,

      item3_image: require('../../assets/landingPage/slider_images/Yaxunah.webp'),
      item3_link:
        '/l/cooperativa-turistica-de-yaxunah-doublebedroom/60dde256-e06b-4019-bbdb-8837b4f704f2',
      item3_header: 'Cooperativa Turistica de Yaxunah',
      item3_location: <FormattedMessage id="yaxunah" />,
      item3_rating: '4.95',
      item3_price: '32$',
    },
    {
      index: 2,
      itemsHeader: <FormattedMessage id="asia" />,
      headline: <FormattedMessage id="landing.story.headline1" />,
      // location: 'Go Pang Na, Cambodia',
      location: <FormattedMessage id="gopangna" />,
      src: require('../../assets/landingPage/slider_images/Go Pang Na_Erfolgsstory.webp'),
      link: '/l/go-pang-na-doublebedroom/6070342c-f804-4c95-ab9d-13aace1ebbb2',
      showAllLink: '/s?bounds=64.09173416%2C169.49644716%2C-14.97311392%2C58.14770588',

      item1_image: require('../../assets/landingPage/slider_images/earth.webp'),
      item1_link: '/l/earth-company-shared-bedroom/606ecffd-5fb6-4a77-a519-2c6fa25a1323',
      item1_header: 'Earth Company',
      item1_location: <FormattedMessage id="ubud" />,
      item1_rating: '4.95',
      item1_price: '23$',
      category1: require('../../assets/categories/education.png'),
      category1Title: <FormattedMessage id="filter.category.education" />,

      item2_image: require('../../assets/landingPage/slider_images/Phangnga.webp'),
      item2_link:
        '/l/naucrates-sea-turtle-and-island-conservation-koh-phra-thong-entire-accomodation/62f676a1-3a55-48ff-96a8-bb2e1bbe83f1',
      item2_header: 'Koh Phra Thong',
      item2_location: <FormattedMessage id="phangnga" />,
      item2_rating: '4.95',
      item2_price: '37$',
      category2: require('../../assets/categories/environment.png'),
      category2Title: <FormattedMessage id="filter.category.environment" />,

      item3_image: require('../../assets/landingPage/slider_images/Bukit.webp'),
      item3_link:
        '/l/project-wings-deluxe-bungalow-entire-accomodation/62de8e5a-4569-4e61-98ac-31eb694a4350',
      item3_header: 'Project Wings',
      item3_location: <FormattedMessage id="bukit" />,
      item3_rating: '4.95',
      item3_price: '18$',
    },

    {
      index: 3,
      itemsHeader: <FormattedMessage id="africa" />,
      /* Chumbe Island  */

      // headline: 'Chumbe Island',
      headline: <FormattedMessage id="chumbe" />,

      location: <FormattedMessage id="zanzibar" />,

      subHeadlineLocation: 'Gaunshanar, Nepal',
      src: require('../../assets/landingPage/slider_images/Chumbe_Erfolgsstories.webp'),
      link: '/l/chumbe-island-coral-park-shared-bedroom/6076f135-d5ac-46a0-9694-45f04752505e',
      showAllLink: '/s?bounds=36.59497175%2C52.76846679%2C-36.15117826%2C-34.86957672',

      /* Kingfisher cottages & Two Dam Sustainable */
      item2_image: require('../../assets/landingPage/slider_images/Montagu.webp'),
      item2_link: '/l/kingfisher-cottages-two-dam-sustainable-entire-accomodation/6377186a-918e-4440-b53a-4dedde0eb347',
      item2_header: 'Kingfisher cottages & Two Dam Sustainable',
      item2_location: <FormattedMessage id="montagu" />,
      item2_rating: '4.95',
      item2_price: '110€',
      category2: require('../../assets/categories/education.png'),
      category2Title: <FormattedMessage id="filter.category.education" />,

      /* Penduka Trust */
      item1_image: require('../../assets/landingPage/slider_images/Penduka.webp'),
      item1_link: '/l/penduka-trust-entire-accomodation/60e46898-fe5d-4e36-8785-c758711ccda7',
      item1_header: 'Penduka Trust',
      item1_location: 'Windhuk, Namibia',
      item1_rating: '4.95',
      item1_price: '65$',
      category1: require('../../assets/categories/education.png'),
      category1Title: <FormattedMessage id="filter.category.education" />,
      /* Woven connect */
      item3_image: require('../../assets/landingPage/slider_images/woven.webp'),
      item3_link: '/1/woven-connect-shared-bedroom/61d450b7-9483-44b3-8691-f4dbaef76ba0',
      item3_header: 'Woven Connect',
      item3_location: <FormattedMessage id="woven" />,
      // item3_location:'Arusha, Tanzania',
      item3_rating: '4.95',
      item3_price: '12$',
    },
  ];

  const slideData2 = [
    /*{
      index: 0,
      headline: <FormattedMessage id="landing.community.headline1" />,
      subHeadline: 'Vincent, Galileo Reporter',
      linkName: 'Tenerife Horse Rescue',
      link: '/l/tenerife-horse-rescue-entire-accomodation/60c79103-28e7-4fc9-8b48-210aeae1b723',
      src: require('../../assets/landingPage/reviews/penduka.jpg'),
    },*/

    {
      index: 0,
      headline: <FormattedMessage id="landing.community.headline6" />,
      subHeadlineNGO: <FormattedMessage id="Slider2.mildred" />,
      linkNameNGO: 'Intiwawa',
      link: 'l/intiwawa-arequipa-intihouse-shared-bedroom/60781b58-6b2c-4506-80b5-213855343cef',
      src: require('../../assets/landingPage/reviews/Mildred.webp'),
    },

    {
      index: 1,
      // var trimmedString = string.substring(0, length);

      headline: <FormattedMessage id="landing.community.headline2" />,
      subHeadlineNoLink: <FormattedMessage id="landing.community.tileOne" />,
      src: require('../../assets/landingPage/reviews/Fenny.webp'),
    },

    {
      index: 2,
      headline: <FormattedMessage id="landing.community.headline5" />,
      subHeadlineNoLink: 'Geo Saison',
      src: require('../../assets/landingPage/reviews/GEOSaison.webp'),
    },

    {
      index: 3,
      headline: <FormattedMessage id="landing.community.headline3" />,
      subHeadline: 'Markus',
      linkName: 'YAWE',
      link: 'l/yawe-foundation-singlebedroom/6089b73e-26df-4dd8-b53e-493cbb2be646',

      src: require('../../assets/landingPage/reviews/markus.webp'),
    },

    {
      index: 4,
      headline: <FormattedMessage id="landing.community.headline7" />,
      linkExternal: <FormattedMessage id="landing.community.titleTwo" />,
      link:
        '/l/zonca-ecovillage-in-piemonte-italy-casa-in-mezzo-entire-accomodation/60f572e2-ed29-4a70-8aa6-232260f00ac7',

      src: require('../../assets/landingPage/reviews/LindaZonca.webp'),
    },
    {
      index: 5,
      headline: <FormattedMessage id="landing.community.headline8" />,
      linkExternal: <FormattedMessage id="landing.community.titleThree" />,
      link: '/l/kawsay-biological-station-twobedroom/61d1d97e-cbe5-4e99-9916-cb81ef66de46',
      src: require('../../assets/landingPage/reviews/PeruRaulbello.webp'),
    },
  ];


  const pageContent = (
    <div style={{ overflow: 'hidden' }}>
      <div
        id="topbar"
        ref={topbarRef}
        className={css.topbar}
        style={{ position: 'fixed', width: '100vw' }}
      >
        <TopbarContainer />
      </div>
      <div
        className={
          'leftFooterTransition ' +
          (typeof window !== 'undefined'
            ? window.location.pathname === '/l/:slug/:id' ||
              ((window.location.pathname === '/' || window.location.pathname === '/about') &&
                sectionLink)
              ? css.LeftFooterContent
              : css.LeftFooterContentHide
            : css.LeftFooterContentHide)
        }
      >
        <ExternalLink
          href="https://www.instagram.com/socialbnb"
          target="_blank"
          className={css.socialmedia}
        >
          <img src={insta} className={css.socialmedia} alt="instagram"></img>
        </ExternalLink>

        <ExternalLink
          href="https://www.facebook.com/Socialbnb"
          target="_blank"
          className={css.socialmedia}
        >
          <img src={fb} className={css.socialmedia} alt="facebook"></img>
        </ExternalLink>

        <ExternalLink
          href="https://www.linkedin.com/company/socialbnb/"
          target="_blank"
          className={css.socialmedia}
        >
          <img src={linkedIn} className={css.socialmedia} alt="facebook"></img>
        </ExternalLink>
      </div>
      <div className={css.section}>
        <div id="heroWrapper" className={css.heroWrapper} ref={heroWrapperRef}>
          <picture>
            <source media="(max-width: 799px)" srcset={heroImageSmall}/>
            <source media="(min-width: 800px)" srcset={heroImage}/>
            <img onLoad={handleImageLoaded} className={css.heroImage} src={heroImage}/>
          </picture>
          <div className={css.HeaderWrapper}>
            <div className={css.HeaderWrapperRow}>
              <h1 id="anima" className={css.Header1} ref={animaRef}>
                <FormattedMessage id="landing.headline1" />
              </h1>
            </div>
            <div id="anima2" className={css.vision} ref={anima2Ref}>
              <h3>
                <FormattedMessage id="landing.subHeadline1" />
                <span style={{ paddingLeft: '7px', paddingRight: '7px' }}>
                  <Logo format="desktop" className={css.logo} style={{ marginTop: '-4px' }} />
                </span>
                <FormattedMessage id="landing.subHeadline2" />{' '}
                <TextTransition
                  style={{ color: '#1c7881' }}
                  inline
                  text={WORDS[textTransitionIndex % WORDS.length]}
                  className="transition-text"
                  springConfig={presets.gentle}
                />
              </h3>
            </div>
          </div>

          <div className={css.bookingLink}>
            <LandingLocationSelect css={css} onChange={handleChange} value={searchRegion} />
            <NamedLink
              name="SearchPage"
              to={{
                search: search,
              }}
              className={css.heroButton}
            >
              <FormattedMessage id="landing.bookingButton" />
            </NamedLink>
          </div>
          {/* <div className={css.cloudsOuter}>
          <img className={css.clouds} src={cloud1} alt=""></img>
          </div> */}
        </div>
      </div>

      <div>
          <h2 className={css.worksSectionHeader}>
            <FormattedMessage id="landing.featured" />
          </h2>
          <br/>
          <br/>
          <PressSection/>
      </div>
      <br/>

      {/*How it works */}
      <SectionMission />
      <h2 className={css.worksSectionHeader}>
        <FormattedMessage id="landing.bookingsHeadline1" />
      </h2>
      <InView>
        {({ inView, ref1, entry }) => {
          return (
            <div ref={ref1} className={css.section1a}>
              <div style={{ width: '95%' }}>
                <SectionSteps/>
              </div>
            </div>
          );
        }}
      </InView>

      {/*Discover our accomodation in */}
      <div className={`${css.section} ${css.section4}`} id="section2">
        <Slider heading="Example Slider" slides={slideData} />
      </div>
      

      {/*Experience Impact Transparency */}
      <SectionHowItWorks />

      
      {/*Feedback from our community*/}
      <div className={`${css.section} ${css.section4}`}>
        
        <Slider2 heading="Example Slider" slides={slideData2} />

      </div>
    
      {/*Footer including Newsletter + Socialmedia*/}
      <div className={`${css.section} ${css.section5}`}>
        <LazyLoad height={400} offset={100} once>
          <Footer />
        </LazyLoad>
      </div>
    </div>
  );

  const loader =
    loadingState === false ? (
      <div className={css.loader}>
        <img src={LoaderImage2} className={css.loaderImage2} width="100px" alt=""></img>

        <img src={LoaderImage1} className={css.loaderImage1} width="100px" alt=""></img>
        {/* <CircularProgress size={50} thickness={2} style={{ color: '#353535' }} /> */}
      </div>
    ) : null;

  // need to get rid of duplicate description and find new content for these tags - weasel
  return (
    <StaticPage
      title={
        cookies.get('language') === 'en'
          ? 'socialbnb - the social travel startup'
          : 'socialbnb - das soziale Reise Startup '
      }
      keywords={
        cookies.get('language') === 'en'
          ? 'socialbnb, social travel startup, fair tourism, social travel, social projects, ecological projects, unique travel experiences, authentic travel experiences'
          : 'socialbnb, soziales Reise Startup, gerechter Tourismus, sozial reisen, soziale Projekte, ökologische Projekte, einzigartige Reiseerlebnisse, authentische Reiseerlebnisse'
      }
      description={
        cookies.get('language') === 'en'
          ? 'Be part of a fair tourism that benefits everyone. Support an ecological or social project by booking with socialbnb - the social travel startup. Unique and authentic travel experiences with social impact.'
          : 'Werde Teil eines gerechten Tourismus, von dem alle profitieren. Unterstütze ein ökologisches oder soziales Projekt durch deine Buchung bei socialbnb - dem sozialen Reise Startup. Einzigartige und authentische Reiseerlebnisse mit sozialem Impact.'
      }
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Organization',
        name: 'socialbnb',
        url: 'https://socialbnb.org/',
      }}
    >
      <div id="my-scrollbar" className={css.Wrapper}>
        {loader} {pageContent}
      </div>
    </StaticPage>
  );
};

export default LandingPage;
